/**
 * Source: https://usehooks-ts.com/react-hook/use-media-query
 */

import { useEffect, useState } from 'react'
import { BREAKPOINTS } from './constants'

export function useMediaQuery(query: string): boolean {
  const getMatches = (q: string): boolean => {
    // Prevents SSR issues
    if (typeof window !== 'undefined') {
      return window.matchMedia(q).matches
    }
    return true
  }

  const [matches, setMatches] = useState<boolean>(true)

  function handleChange() {
    setMatches(getMatches(query))
  }

  useEffect(() => {
    const matchMedia = window.matchMedia(query)

    // Triggered at the first client-side load and if query changes
    handleChange()

    // Listen matchMedia
    matchMedia.addEventListener('change', handleChange)

    return () => {
      matchMedia.removeEventListener('change', handleChange)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query])

  return matches
}

export const useBreakpoint = () => {
  const isMd = useMediaQuery(
    `(min-width: ${BREAKPOINTS.MD}px) and (max-width: ${BREAKPOINTS.LG}px)`,
  )
  const isLg = useMediaQuery(`(min-width: ${BREAKPOINTS.LG}px)`)

  return {
    isLg,
    isMd: isMd && !isLg,
    isSm: !isMd && !isLg,
  }
}
